import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin} from '../common/common.js';

import './modal-body.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Modal.Body',
    classNames: {
      main: 'uu5-bricks-modal-body modal-body'
    },
    defaults: {
      parentTagName: 'UU5.Bricks.Modal'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <div {...this.buildMainAttrs()}>
        {this.getChildren()}
        {this.getDisabledCover()}
      </div>
    );
  }
  //@@viewOff:render
});


// WEBPACK FOOTER //
// ./bricks/modal-body.js